import * as auctions from "./auctions";
import * as calendar from "./calendar";
import * as categories from "./categories";
import * as contentMenu from "./contentMenu";
import * as contentPage from "./contentPage";
import * as featured from "./featured";
import * as locales from "./locales";
import * as translations from "./translations";

export default {
  ...auctions,
  ...calendar,
  ...categories,
  ...contentMenu,
  ...contentPage,
  ...featured,
  ...locales,
  ...translations
};



// WEBPACK FOOTER //
// ./src/redux/api/index.js